import React from 'react';
import { Button } from 'react-bootstrap';

export default function SetupStep5(props) {
    return (
        <React.Fragment>
            <div className="row mb-3 p-5 text-center">
                <p>
                    {props.MODE == 'create'
                        ? "Your Setup Mapppings were saved."
                        : "Your Setup Mappings were updated."
                    }
                </p>
                <p>
                    <Button
                        size="md"
                        href={process.env.REACT_APP_DS_HOME}
                        >
                        Home
                    </Button>
                </p>
            </div>
        </React.Fragment>
    )
}